// extracted by mini-css-extract-plugin
export var burgerIcon = "burgerMenuIcon-module--burgerIcon--a0f9a";
export var closed = "burgerMenuIcon-module--closed--81492";
export var opened = "burgerMenuIcon-module--opened--5825a";